import { getBmsInfo, getStatementInfo } from './manageDaskApi';
import { getSettleLists } from '@/modules/transport/bms/api/settleApi.js';
import { extsysInvoiceQuery } from '@/modules/transport/bms/api/invoiceManageApi.js';
import { getBillLists } from '@/modules/transport/bms/api/billApi.js';
import { querySupTask } from '@/modules/transport/bms/api/noTaxDebtProofApi.js';

import store from '@/store/index.js';

const supplier = store.getters.supplier;
const btnPermissions = store.getters.btnPermissions;

/* 设置财务待办统计数 */
export const setFinancialToDoNum = (config = []) => {
    const setNum = (code, num) => {
        config[code].value = num;
    };

    
    if (!btnPermissions.includes('/storeWorkbench-40')) {
        setNum('checkFee', 0)
        setNum('checkBill', 0)
        setNum('settlementApply', 0)
        setNum('invoiceManagement', 0)
        setNum('dealingsCheckBill', 0)
        setNum('noTaxDebtProof', 0)
        return;
    }
    
    getBmsInfo().then((res) => {
        if (res) {
            const { feeTask } = res.data;
            setNum('checkFee', feeTask); // 费用核对
        }
    });
    getBillLists({
        billStatus: '30' // 新建和驳回
    }).then((res) => {
        if (res && +res.code === 0) {
            setNum('checkBill', res.data.totalCount); // 账单核对
        }
    });
    getSettleLists({
        statusArray: '10,47' // 新建和驳回
    }).then((res) => {
        if (res && +res.code === 0) {
            setNum('settlementApply', res.data.totalCount); // 结算申请
        }
    });
    extsysInvoiceQuery({
        makeInvoiceStatuses: '60,90'
    }).then((res) => {
        if (res && +res.code === 0) {
            setNum('invoiceManagement', res.data.totalCount); // 发票管理
        }
    });
    getStatementInfo({
        accountMode: 'A',
        dealingsBillStatuses: '20,30,50',
        isManage: 0,
        isSup: 1,
        isOrder: 1,
        supCode: supplier.supplierCode
    }).then(res => {
        setNum('dealingsCheckBill', res.data.totalCount); // 往来对账单
    });
    querySupTask({
        taskStatus: 'UN_SUBMIT',
        pageSize: 1000000
    }).then(res => {
        setNum('noTaxDebtProof', res.data.totalCount); // 无欠税证明
    });
};

export const financialToDoConfig = {
    checkFee: {
        code: 'checkFee',
        label: '费用核对',
        value: 0,
        auth: '/index-bms-180',
        desc: '状态=待确认',
        pageParams: {
            path: '/bms/cost',
            query: {
                status: '30',
                from: 'todoList'
            }
        }
    },
    checkBill: {
        code: 'checkBill',
        label: '账单核对',
        value: 0,
        auth: '/index-bms-180',
        desc: '状态=待确认',
        pageParams: {
            path: '/bms/bill',
            query: {
                billStatus: '30',
                from: 'todoList'
            }
        }
    },
    settlementApply: {
        code: 'settlementApply',
        label: '结算申请',
        value: 0,
        auth: '/index-bms-180',
        desc: '单据状态=新建，驳回',
        pageParams: {
            path: '/bms/settle',
            query: {
                status: '10,47',
                from: 'todoList'
            }
        }
    },
    invoiceManagement: {
        code: 'invoiceManagement',
        label: '发票管理',
        value: 0,
        auth: '/index-bms-180',
        desc: '发票状态=待红冲，红冲后待开',
        pageParams: {
            path: '/bms/invoiceManage',
            query: {
                makeInvoiceStatuses: '60,90',
                from: 'todoList'
            }
        }
    },
    dealingsCheckBill: {
        code: 'dealingsCheckBill',
        label: '往来对账单',
        value: 0,
        auth: '/index-bms-180',
        desc: '对账单状态=已发函、供方确认一直、已回复差异',
        pageParams: {
            path: '/bms/statement',
            query: {
                accountMode: 'A',
                dealingsBillStatus: '20,30,50',
                from: 'todoList'
            }
        }
    },
    noTaxDebtProof: {
        code: 'noTaxDebtProof',
        label: '无欠税证明',
        value: 0,
        auth: '/index-bms-180',
        desc: '单据状态=待提交',
        pageParams: {
            path: '/bms/noTaxDebtProof',
            query: {
                taskStatus: 'UN_SUBMIT',
                from: 'todoList'
            }
        }
    }
};
